import client from '../client';
import endpoints from '../endpoints';

/**
 * 투어 — 서비스 + 관리자 API
 * API_DOCS: 9. 투어 / 23. 관리자 - 투어
 */

/* ── 서비스 (유저용) ── */

export const getTours = async (params = {}) => {
  const res = await client.get(endpoints.tours.list, { params });
  return res.data;
};

export const getTourById = async (id) => {
  const res = await client.get(endpoints.tours.detail(id));
  return res.data;
};

export const getTourSchedules = async (tourId) => {
  const res = await client.get(endpoints.tours.schedules(tourId));
  return res.data;
};

export const createTourReservation = async (tourId, data) => {
  const res = await client.post(endpoints.tours.createReservation(tourId), data);
  return res.data;
};

/* ── 관리자 ── */

export const getAdminTours = async (params = {}) => {
  const res = await client.get(endpoints.admin.tours.list, { params });
  return res.data;
};

export const getAdminTourById = async (id) => {
  const res = await client.get(endpoints.admin.tours.detail(id));
  return res.data;
};

export const createTour = async (data) => {
  const res = await client.post(endpoints.admin.tours.list, data);
  return res.data;
};

export const updateTour = async (id, data) => {
  const res = await client.put(endpoints.admin.tours.detail(id), data);
  return res.data;
};

export const deleteTour = async (id) => {
  const res = await client.delete(endpoints.admin.tours.detail(id));
  return res.data;
};

export const getAdminTourSchedules = async (tourId) => {
  const res = await client.get(endpoints.admin.tours.schedules(tourId));
  return res.data;
};

export const createTourSchedule = async (tourId, data) => {
  const res = await client.post(endpoints.admin.tours.schedules(tourId), data);
  return res.data;
};

export const updateTourSchedule = async (tourId, scheduleId, data) => {
  const res = await client.put(endpoints.admin.tours.scheduleDetail(tourId, scheduleId), data);
  return res.data;
};

export const deleteTourSchedule = async (tourId, scheduleId) => {
  const res = await client.delete(endpoints.admin.tours.scheduleDetail(tourId, scheduleId));
  return res.data;
};
